export enum ParameterVariable {
  MOVEMENT_AMPLITUDE = 'Movement Amplitude',
  VELOCITY = 'Velocity',
  ACCELERATION = 'Acceleration',
}
